export default __webpack_public_path__ + "static/media/3sentences.abe27491.wav";